import { P2 } from "./P2";
import { ReactNode } from "react";
import { cn } from "../../ClassName";

interface Props {
  className?: string;
  children?: ReactNode;
  id?: string;
}

export function P2B(props: Props) {
  return (
    <P2 className={cn(`tw-font-bold`, props.className)} id={props.id}>
      {props.children}
    </P2>
  );
}
